import React, { useState } from 'react'
import { ArrowUpRight } from 'lucide-react'

const Portfolio = () => {
  const [selectedCategory, setSelectedCategory] = useState('All')

  const categories = ['All', 'Residential', 'Commercial', 'Hospitality']

  const projects = [
    {
      id: 1,
      title: 'Luxury Penthouse',
      category: 'Residential',
      image: 'https://images.unsplash.com/photo-1600210492493-0946911123ea?w=800&q=80',
      description: 'Modern luxury living with panoramic city views',
      area: '3500 sq ft',
      year: '2024'
    },
    {
      id: 2,
      title: 'Contemporary Villa',
      category: 'Residential',
      image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80',
      description: 'Minimalist design with natural elements',
      area: '4200 sq ft',
      year: '2024'
    },
    {
      id: 3,
      title: 'Corporate Headquarters',
      category: 'Commercial',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80',
      description: 'Innovative workspace design for tech company',
      area: '15000 sq ft',
      year: '2023'
    },
    {
      id: 4,
      title: 'Boutique Hotel Suite',
      category: 'Hospitality',
      image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80',
      description: 'Elegant luxury accommodation design',
      area: '800 sq ft',
      year: '2023'
    },
    {
      id: 5,
      title: 'Modern Apartment',
      category: 'Residential',
      image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80',
      description: 'Smart home integration with contemporary aesthetics',
      area: '2100 sq ft',
      year: '2024'
    },
    {
      id: 6,
      title: 'Restaurant Interior',
      category: 'Hospitality',
      image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&q=80',
      description: 'Fine dining experience with ambient design',
      area: '3000 sq ft',
      year: '2023'
    },
    {
      id: 7,
      title: 'Executive Office',
      category: 'Commercial',
      image: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800&q=80',
      description: 'Sophisticated workspace for C-suite executives',
      area: '1200 sq ft',
      year: '2024'
    },
    {
      id: 8,
      title: 'Coastal Residence',
      category: 'Residential',
      image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&q=80',
      description: 'Beachfront property with ocean-inspired design',
      area: '5000 sq ft',
      year: '2023'
    },
    {
      id: 9,
      title: 'Spa & Wellness Center',
      category: 'Hospitality',
      image: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80',
      description: 'Tranquil retreat design for ultimate relaxation',
      area: '6000 sq ft',
      year: '2024'
    }
  ]

  const filteredProjects = selectedCategory === 'All' 
    ? projects 
    : projects.filter(project => project.category === selectedCategory)

  return (
    <div data-component-path="client/src/pages/Portfolio.jsx" data-component-line="1:1" data-component-id="client/src/pages/Portfolio.jsx:1:1" className="pt-20">
      <section data-component-path="client/src/pages/Portfolio.jsx" data-component-line="2:3" data-component-id="client/src/pages/Portfolio.jsx:2:3" className="py-20 bg-stone-50">
        <div data-component-path="client/src/pages/Portfolio.jsx" data-component-line="3:5" data-component-id="client/src/pages/Portfolio.jsx:3:5" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div data-component-path="client/src/pages/Portfolio.jsx" data-component-line="4:7" data-component-id="client/src/pages/Portfolio.jsx:4:7" className="text-center mb-12">
            <h1 data-component-path="client/src/pages/Portfolio.jsx" data-component-line="5:9" data-component-id="client/src/pages/Portfolio.jsx:5:9" className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 hero-title">Our Portfolio</h1>
            <p data-component-path="client/src/pages/Portfolio.jsx" data-component-line="6:9" data-component-id="client/src/pages/Portfolio.jsx:6:9" className="text-xl text-gray-600 max-w-3xl mx-auto">
              Explore our collection of completed projects showcasing innovative design solutions and exceptional craftsmanship
            </p>
          </div>

          <div data-component-path="client/src/pages/Portfolio.jsx" data-component-line="7:7" data-component-id="client/src/pages/Portfolio.jsx:7:7" className="flex flex-wrap justify-center gap-4 mb-12">
            {categories.map((category) => (
              <button data-component-path="client/src/pages/Portfolio.jsx" data-component-line="8:9" data-component-id="client/src/pages/Portfolio.jsx:8:9"
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`h-11 px-6 rounded-lg font-medium transition-all duration-200 ${
                  selectedCategory === category
                    ? 'bg-amber-600 text-white shadow-md'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          <div data-component-path="client/src/pages/Portfolio.jsx" data-component-line="9:7" data-component-id="client/src/pages/Portfolio.jsx:9:7" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project) => (
              <div data-component-path="client/src/pages/Portfolio.jsx" data-component-line="10:9" data-component-id="client/src/pages/Portfolio.jsx:10:9"
                key={project.id}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer"
              >
                <div data-component-path="client/src/pages/Portfolio.jsx" data-component-line="11:11" data-component-id="client/src/pages/Portfolio.jsx:11:11" className="relative h-64 overflow-hidden">
                  <img data-component-path="client/src/pages/Portfolio.jsx" data-component-line="12:13" data-component-id="client/src/pages/Portfolio.jsx:12:13"
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = 'https://images.unsplash.com/photo-1600210492493-0946911123ea?w=800&q=80'
                    }}
                  />
                  <div data-component-path="client/src/pages/Portfolio.jsx" data-component-line="13:13" data-component-id="client/src/pages/Portfolio.jsx:13:13" className="absolute top-4 right-4 bg-amber-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {project.category}
                  </div>
                  <div data-component-path="client/src/pages/Portfolio.jsx" data-component-line="14:13" data-component-id="client/src/pages/Portfolio.jsx:14:13" className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-end p-4">
                    <div data-component-path="client/src/pages/Portfolio.jsx" data-component-line="15:15" data-component-id="client/src/pages/Portfolio.jsx:15:15" className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
                      <ArrowUpRight data-component-path="client/src/pages/Portfolio.jsx" data-component-line="16:17" data-component-id="client/src/pages/Portfolio.jsx:16:17" className="w-5 h-5 text-amber-600 flex-shrink-0" />
                    </div>
                  </div>
                </div>
                <div data-component-path="client/src/pages/Portfolio.jsx" data-component-line="17:11" data-component-id="client/src/pages/Portfolio.jsx:17:11" className="p-6">
                  <h3 data-component-path="client/src/pages/Portfolio.jsx" data-component-line="18:13" data-component-id="client/src/pages/Portfolio.jsx:18:13" className="text-2xl font-bold text-gray-900 mb-2 hero-title">{project.title}</h3>
                  <p data-component-path="client/src/pages/Portfolio.jsx" data-component-line="19:13" data-component-id="client/src/pages/Portfolio.jsx:19:13" className="text-gray-600 mb-4">{project.description}</p>
                  <div data-component-path="client/src/pages/Portfolio.jsx" data-component-line="20:13" data-component-id="client/src/pages/Portfolio.jsx:20:13" className="flex items-center justify-between text-sm text-gray-500">
                    <span data-component-path="client/src/pages/Portfolio.jsx" data-component-line="21:15" data-component-id="client/src/pages/Portfolio.jsx:21:15">{project.area}</span>
                    <span data-component-path="client/src/pages/Portfolio.jsx" data-component-line="22:15" data-component-id="client/src/pages/Portfolio.jsx:22:15">{project.year}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Portfolio